(function(){
  function initFlyerCarousel(root){
    if (!root || root.dataset.fcInited === 'true') return;
    root.dataset.fcInited = 'true';

    const productsWrap = root.querySelector('.products-carousel');
    const sectionId = productsWrap ? productsWrap.dataset.carouselId : '';
    const track = root.querySelector('.products-carousel__track');
    const slides = Array.from(root.querySelectorAll('.products-carousel__slide'));
    const prevBtn = root.querySelector('.products-carousel__btn--prev');
    const nextBtn = root.querySelector('.products-carousel__btn--next');
    const dotsWrap = root.querySelector('.products-carousel__dots');

    // Modal (mover al body para evitar recortes/z-index)
    const modal = document.getElementById(`variantModal-${sectionId}`);
    const optionsBox = document.getElementById(`variantOptions-${sectionId}`);
    if (modal && modal.parentElement !== document.body) {
      try { document.body.appendChild(modal); } catch(e){}
    }

    if (!track || slides.length === 0) return;

    // ==== Paginación (3/2/1) ====
    let perRow = getPerRow();
    let totalPages = Math.max(1, Math.ceil(slides.length / perRow));
    let current = 0;

    buildDots();
    renderPage(0);
    bindNav();
    bindAddToCart();
    bindVariantChooser();
    bindModalClose();

    // Resize con debounce por rAF
    let rAF;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(rAF);
      rAF = requestAnimationFrame(() => {
        const newPerRow = getPerRow();
        const newTotal = Math.max(1, Math.ceil(slides.length / newPerRow));
        if (newPerRow !== perRow || newTotal !== totalPages){
          perRow = newPerRow;
          totalPages = newTotal;
          buildDots();
          current = Math.min(current, totalPages - 1);
          renderPage(current);
        }
      });
    }, { passive: true });

    function getPerRow(){
      const w = window.innerWidth;
      if (w <= 575) return 1;
      if (w <= 1024) return 2;
      return 3;
    }

    function buildDots(){
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      if (totalPages <= 1) { dotsWrap.style.display = 'none'; return; }
      dotsWrap.style.display = 'flex';
      for (let i=0;i<totalPages;i++){
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'dot' + (i===0 ? ' active' : '');
        btn.setAttribute('aria-pressed', i===0 ? 'true' : 'false');
        btn.addEventListener('click', () => { renderPage(i); });
        dotsWrap.appendChild(btn);
      }
    }

    function updateDots(idx){
      if (!dotsWrap) return;
      const dots = dotsWrap.querySelectorAll('.dot');
      dots.forEach((d,i)=>{
        d.classList.toggle('active', i===idx);
        d.setAttribute('aria-pressed', i===idx ? 'true' : 'false');
      });
    }

    function renderPage(idx){
      current = idx;
      slides.forEach(s => { s.style.display = 'none'; });
      const start = idx * perRow;
      const end = Math.min(start + perRow, slides.length);
      for (let i = start; i < end; i++){
        slides[i].style.display = 'block';
      }
      updateDots(idx);
      updateNav(idx);
    }

    function updateNav(idx){
      if (prevBtn){ prevBtn.disabled = (idx === 0); }
      if (nextBtn){ nextBtn.disabled = (idx >= totalPages - 1); }
    }

    function bindNav(){
      if (prevBtn) prevBtn.addEventListener('click', () => { if (current>0) renderPage(current-1); });
      if (nextBtn) nextBtn.addEventListener('click', () => { if (current<totalPages-1) renderPage(current+1); });
    }

    // ==== Añadir al carrito (variantes simples) ====
    function bindAddToCart(){
      const addBtns = root.querySelectorAll('.js-add[data-variant-id]');
      addBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          if (btn.disabled) return;
          const id = btn.getAttribute('data-variant-id');
          quickAdd(id, btn);
        });
      });
    }

    // ==== Elegir variante (abrir modal) ====
    function bindVariantChooser(){
      root.addEventListener('click', function(e){
        const chooseBtn = e.target.closest('.js-choose');
        if (!chooseBtn || !root.contains(chooseBtn)) return;

        const handle = chooseBtn.getAttribute('data-product-handle');
        if (!handle) return;

        // Abre modal y carga
        openModal();
        optionsBox.innerHTML = '<div style="padding:10px">Cargando variantes…</div>';

        fetch(`/products/${encodeURIComponent(handle)}.js`)
          .then(r => { if (!r.ok) throw new Error('No se pudo cargar el producto'); return r.json(); })
          .then(product => {
            const variants = Array.isArray(product.variants) ? product.variants : [];
            if (!variants.length) {
              optionsBox.innerHTML = '<div style="padding:10px;color:#B0004B">Este producto no tiene variantes disponibles.</div>';
              return;
            }

            optionsBox.innerHTML = variants.map(v => {
              const soldOut = !v.available;
              return `
                <div class="fc-variant ${soldOut ? 'is-soldout' : ''}">
                  <span>${v.title}${soldOut ? ' — Agotado' : ''}</span>
                  <button class="fc-variant__btn js-variant-add"
                          data-variant-id="${v.id}"
                          ${soldOut ? 'disabled aria-disabled="true" title="Sin stock"' : ''}>
                    ${soldOut ? 'Agotado' : 'Añadir'}
                  </button>
                </div>
              `;
            }).join('');
          })
          .catch(() => {
            optionsBox.innerHTML = '<div style="padding:10px;color:#B0004B">Error al cargar variantes.</div>';
          });
      });

      // Click dentro del modal para añadir variante
      optionsBox.addEventListener('click', function(e){
        const btn = e.target.closest('.js-variant-add');
        if (!btn || btn.disabled) return;
        const id = btn.getAttribute('data-variant-id');
        btn.textContent = 'Agregando...';
        btn.disabled = true;

        quickAdd(id).then(() => closeModal()).finally(() => {
          btn.textContent = 'Añadir';
          btn.disabled = false;
        });
      });
    }

    // ==== Modal helpers ====
    function openModal(){
      if (!modal) return;
      modal.style.display = 'block';
      modal.setAttribute('aria-hidden','false');
      document.body.style.overflow = 'hidden';
      const closeBtn = modal.querySelector('[data-fc-close]');
      if (closeBtn) closeBtn.focus();
    }
    function closeModal(){
      if (!modal) return;
      modal.style.display = 'none';
      modal.setAttribute('aria-hidden','true');
      document.body.style.overflow = '';
    }
    function bindModalClose(){
      if (!modal) return;
      modal.addEventListener('click', (e) => {
        if (e.target === modal || e.target.closest('[data-fc-close]')) {
          e.preventDefault(); closeModal();
        }
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.style.display === 'block') closeModal();
      });
    }

    // ==== Ajax cart + burbuja ====
    function quickAdd(variantId, btn){
      if (!variantId) return Promise.resolve();
      const original = btn ? btn.textContent : '';
      if (btn){ btn.textContent = 'Agregando...'; btn.disabled = true; }

      return fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(r => r.json())
      .then(() => {
        if (btn){ btn.textContent = '¡Añadido!'; setTimeout(()=>{ btn.textContent = original; btn.disabled = false; }, 1200); }
        updateCartBubble();
      })
      .catch(() => {
        if (btn){ btn.textContent = 'Error'; setTimeout(()=>{ btn.textContent = original; btn.disabled = false; }, 1200); }
      });
    }

    function updateCartBubble(){
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const cartIcon = document.querySelector('.header__icon--cart');
          if (!cartIcon) return;
          let bubble = cartIcon.querySelector('.cart-count-bubble');
          if (!bubble){
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            bubble.innerHTML = `
              <span aria-hidden="true">${cart.item_count}</span>
              <span class="visually-hidden">${cart.item_count} artículo${cart.item_count !== 1 ? 's' : ''}</span>`;
            cartIcon.appendChild(bubble);
          } else {
            const n = bubble.querySelector('span[aria-hidden="true"]');
            const sr = bubble.querySelector('.visually-hidden');
            if (n) n.textContent = cart.item_count;
            if (sr) sr.textContent = `${cart.item_count} artículo${cart.item_count !== 1 ? 's' : ''}`;
          }
        });
    }
  }

  function initAll(){
    document.querySelectorAll('.flyer-carousel').forEach(initFlyerCarousel);
  }

  // Soporte editor Shopify
  ['DOMContentLoaded','shopify:section:load','shopify:section:select'].forEach(evt=>{
    document.addEventListener(evt, initAll, { passive:true });
  });
})();




